import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Card from 'reactstrap/lib/Card';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { PUB_STATES } from 'client/constants/pub-states';
import { Link } from 'site-modules/shared/components/link/link';
import { VehicleDropdowns } from 'site-modules/shared/components/vehicle-dropdowns/vehicle-dropdowns';

import './indexred.scss';

export function generateLink(make, model) {
  return model ? `/${make.slug}/${model.slug}/connect/` : null;
}

function IndexredUI({ isMobile }) {
  return (
    <Container tag="main" id="main-content" className="indexred pt-3_5">
      <Row>
        <Col xs={12} lg={9} xl={8}>
          <Card className="pos-r bg-white py-1 px-md-1">
            <h1
              className={classnames('align-self-md-end heading-1 fw-bold text-primary px-0_5 ps-md-0 pe-md-1_5', {
                'heading-1': !isMobile,
                'heading-2': isMobile,
              })}
            >
              {"Let's find your perfect car."}
            </h1>
            {!isMobile && (
              <img
                className="car-image ms-1 mt-0_75"
                src={getStaticImageUrl('/img/affiliate/car-blue-173x110.png')}
                width={173}
                height={110}
                alt="Car"
              />
            )}
            <Row className="flex-column flex-md-row align-items-md-end bg-primary mx-0 p-0_5">
              <Col xs={12} md={7} className="text-white px-0 px-md-1_5 pt-md-3_5 pb-md-1_5">
                <div className="fw-bold mb-0_5">Shop thousands of new cars and save on the one you want.</div>
                <div>Easier car buying begins here</div>
              </Col>
              <Col xs={12} md={5} className="card bg-white mt-1_5 mt-md-0">
                <VehicleDropdowns
                  hasModel
                  showButtonGroup
                  isStyledSelects
                  generateLink={generateLink}
                  globalClasses="flex-column py-1 px-md-1"
                  modelDropdownClassNames="px-0"
                  buttonGroupClassNames="mt-0_5 w-100"
                  buttonColor="primary-b"
                  buttonClassNames="px-1_25 py-0_5 w-100"
                  showArrowButton={false}
                  pubStates={[PUB_STATES.NEW, PUB_STATES.NEW_USED]}
                />
              </Col>
            </Row>
            <div className="text-center pt-0_75">
              <Link className="continue-link xsmall text-primary-darker" to="/new-cars/">
                Continue without selecting Make & Model
              </Link>
            </div>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

IndexredUI.propTypes = {
  isMobile: PropTypes.bool,
};

IndexredUI.defaultProps = {
  isMobile: false,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const Indexred = connect(mapStateToProps)(IndexredUI);
